import React from "react";

const DeleteIcon = ({ onClick, size = "25" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: "pointer" }}
      onClick={onClick}
    >
      <path
        d="M7.5 21.5C6.95 21.5 6.47933 21.3043 6.088 20.913C5.69667 20.5217 5.50067 20.0507 5.5 19.5V6.5H4.5V4.5H9.5V3.5H15.5V4.5H20.5V6.5H19.5V19.5C19.5 20.05 19.3043 20.521 18.913 20.913C18.5217 21.305 18.0507 21.5007 17.5 21.5H7.5ZM17.5 6.5H7.5V19.5H17.5V6.5ZM9.5 17.5H11.5V8.5H9.5V17.5ZM13.5 17.5H15.5V8.5H13.5V17.5Z"
        fill="#ED4C5C"
      />
    </svg>
  );
};

export default DeleteIcon;
